'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Layout from 'Layouts/Front';
import SearchWidget from 'Components/Front/SearchWidget';
import EtablishmentsMapBlock from 'Components/Blocks/EtablishmentsMapBlock';
import EtablishmentsSlider from 'Components/Blocks/EtablishmentsSlider';
import DiscountCodeBanner from 'Components/Blocks/DiscountCodeBanner';
import SpacesTypesBlock from 'Components/Blocks/SpacesTypesBlock';
import HomeBanner from 'Components/Blocks/HomeBanner';
import NewsBlock from 'Components/Blocks/NewsBlock';
import bemit from 'Functions/bemit';
import { FRONT_ENV } from '../../front_env';
const {
  moment
} = window;
const IS_PREPROD = FRONT_ENV !== 'prod';
export default class HomePage extends Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const display__tmp_banner = IS_PREPROD ? false : moment().isAfter('2024-06-10', 'day') && moment().isBefore('2024-06-21', 'day');
    const modifiers = ['home'].concat(display__tmp_banner ? ['discount-code'] : []);
    const sub_footer = display__tmp_banner ? /*#__PURE__*/React.createElement("p", {
      className: "c-footer__legal-conditions"
    }, "*Cette offre est valable uniquement sur le montant de la r\xE9servation dans les espaces Lounge participants, avec un achat minimum de deux heures. Elle ne couvre pas les services suppl\xE9mentaires \xE9ventuels et est limit\xE9e \xE0 une utilisation par personne.") : undefined;
    let output = /*#__PURE__*/React.createElement(Layout, _extends({}, props, {
      "sub-footer": sub_footer
    }), /*#__PURE__*/React.createElement("header", {
      className: bemit('c-front-page-intro', modifiers)
    }, display__tmp_banner ? /*#__PURE__*/React.createElement(DiscountCodeBanner, null) : /*#__PURE__*/React.createElement(HomeBanner, null), /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__widget"
    }, /*#__PURE__*/React.createElement(SearchWidget, {
      bemit: ['home'],
      "no-init-fetch": true
    }))), /*#__PURE__*/React.createElement(EtablishmentsSlider, {
      slider: true,
      bemit: ['home'],
      pagination: false
    }), /*#__PURE__*/React.createElement(SpacesTypesBlock, {
      bemit: ['home']
    }), /*#__PURE__*/React.createElement(EtablishmentsMapBlock, null), /*#__PURE__*/React.createElement(NewsBlock, {
      bemit: ['home']
    }));
    return output;
  }
}
